<template>
  <page-wrapper :title="title">
    <div class="create-introduction-container container">
      <FeatureIntroductionEditor
        :form="featureIntroductionPresenter"
        @addPage="handleOnAddPage"
        @deletePage="handleOnDeleteFeatureIntroductionPage"
        @textInputChange="handleOnTextInputChange"
        @imageChanged="handleOnImageChange"
      />
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";

import FeatureIntroductionEditor from "../components/FeatureIntroductionEditor.vue";
import { FeatureIntroductionPresenter } from "@/presenters/featureIntroduction/FeatureIntroductionPresenter";

export default {
  data() {
    const title = "สร้าง Feature Introduction ใหม่";
    const form = {
      platform: {
        iOS: {
          isSelected: false,
          version: ""
        },
        android: {
          isSelected: false,
          version: ""
        }
      },
      pageList: [
        {
          title: "",
          message: "",
          imageFile: null
        }
      ]
    };

    return {
      title,
      form
    };
  },
  computed: {
    featureIntroductionPresenter() {
      return new FeatureIntroductionPresenter(this.form);
    }
  },
  components: {
    PageWrapper,
    FeatureIntroductionEditor
  },
  methods: {
    handleOnAddPage() {
      this.form.pageList.push({
        title: "",
        message: "",
        imageFile: null
      });
    },
    handleOnTextInputChange(valueChanged) {
      const { formName, pageIndex, newValue, oldValue } = valueChanged;
      switch (formName) {
        case "title":
          this.$set(this.form.pageList, pageIndex, {
            ...oldValue,
            title: newValue
          });
          break;
        case "message":
          this.$set(this.form.pageList, pageIndex, {
            ...oldValue,
            message: newValue
          });
          break;
        default:
          console.error("Invalid Feature Introduction Form");
      }
    },
    handleOnImageChange(imageChanged) {
      const { pageIndex, imageFile, oldValue } = imageChanged;
      this.$set(this.form.pageList, pageIndex, {
        ...oldValue,
        imageFile
      });
    },
    handleOnFormChange(newValue) {
      const { pageIndex, newFormValue } = newValue;
    },
    handleOnDeleteFeatureIntroductionPage(pageIndexToDelete) {
      const newPageList = this.form.pageList.filter(
        (page, pageIndex) => pageIndex !== pageIndexToDelete
      );
      this.$set(this.form, "pageList", newPageList);
    }
  }
};
</script>

<style lang="scss" scoped>
.create-introduction-container {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/featureIntroduction/pages/FeatureIntroductionCreatePage.vue